export default __webpack_public_path__ + "static/media/3.e37b0df7.png";